import { render, staticRenderFns } from "./NvSection.vue?vue&type=template&id=4e620089&scoped=true&"
import script from "./NvSection.vue?vue&type=script&lang=js&"
export * from "./NvSection.vue?vue&type=script&lang=js&"
import style0 from "./NvSection.vue?vue&type=style&index=0&id=4e620089&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e620089",
  null
  
)

export default component.exports